var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "统一上传小程序",
        visible: _vm.visible,
        width: "95%",
        "append-to-body": "",
        "close-on-click-modal": false,
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
        close: _vm.handleClose,
      },
    },
    [
      _c(
        "el-form",
        {
          ref: "batchForm",
          attrs: {
            model: _vm.form,
            rules: _vm.rules,
            "label-width": "90px",
            size: "small",
          },
        },
        [
          _c(
            "el-row",
            { attrs: { gutter: 20 } },
            [
              _c(
                "el-col",
                { attrs: { span: 5 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "接口环境", prop: "environmentCode" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          on: { change: _vm.applyEnvironmentToAll },
                          model: {
                            value: _vm.form.environmentCode,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "environmentCode", $$v)
                            },
                            expression: "form.environmentCode",
                          },
                        },
                        _vm._l(_vm.environments, function (item) {
                          return _c("el-option", {
                            key: item.code,
                            attrs: { label: item.name, value: item.code },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { attrs: { span: 5 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "更新体验版" } },
                    [
                      _c("el-switch", {
                        on: { change: _vm.applyTrialRequestedToAll },
                        model: {
                          value: _vm.form.trialRequested,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "trialRequested", $$v)
                          },
                          expression: "form.trialRequested",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { attrs: { span: 14 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "版本描述", prop: "versionDesc" } },
                    [
                      _c("el-input", {
                        attrs: {
                          maxlength: "200",
                          "show-word-limit": "",
                          placeholder: "所选小程序统一使用此描述",
                        },
                        model: {
                          value: _vm.form.versionDesc,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.form,
                              "versionDesc",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "form.versionDesc",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.form.environmentCode === "CUSTOM"
            ? _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "统一目标域名",
                            prop: "customDomain",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              maxlength: "255",
                              placeholder: "https://example.com",
                            },
                            on: { input: _vm.applyCustomDomainToAll },
                            model: {
                              value: _vm.form.customDomain,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.form,
                                  "customDomain",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "form.customDomain",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "selection-tip" }, [
        _vm._v("已选择 " + _vm._s(_vm.selectedRows.length) + " 个小程序"),
      ]),
      _vm._v(" "),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          ref: "appTable",
          attrs: {
            data: _vm.appRows,
            border: "",
            size: "mini",
            "max-height": "520",
          },
          on: { "selection-change": _vm.handleSelectionChange },
        },
        [
          _c("el-table-column", {
            attrs: { type: "selection", width: "45", fixed: "left" },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "id", label: "ID", width: "60" },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "appName",
              label: "小程序名称",
              "min-width": "150",
              "show-overflow-tooltip": "",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "appId",
              label: "AppID",
              "min-width": "155",
              "show-overflow-tooltip": "",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "版本号", "min-width": "145" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-tooltip",
                      {
                        attrs: {
                          disabled: !scope.row.wechatApiReady,
                          content: scope.row.onlineVersion
                            ? "微信线上版本：" +
                              scope.row.onlineVersion +
                              "，本次自动使用线上版本 +1"
                            : "已接入服务商，但微信侧暂无线上版本",
                          placement: "top",
                        },
                      },
                      [
                        _c("el-input", {
                          attrs: {
                            size: "mini",
                            maxlength: "64",
                            readonly: scope.row.versionNoReadonly,
                            placeholder: scope.row.wechatApiReady
                              ? "暂无可用线上版本"
                              : "请输入版本号",
                          },
                          model: {
                            value: scope.row.versionNo,
                            callback: function ($$v) {
                              _vm.$set(
                                scope.row,
                                "versionNo",
                                typeof $$v === "string" ? $$v.trim() : $$v
                              )
                            },
                            expression: "scope.row.versionNo",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    scope.row.wechatApiReady
                      ? _c("div", { staticClass: "version-source" }, [
                          _vm._v(
                            "\n          线上：" +
                              _vm._s(
                                scope.row.onlineVersion || "暂无正式版本"
                              ) +
                              "\n        "
                          ),
                        ])
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "Git分支", "min-width": "230" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("el-input", {
                      attrs: { size: "mini", placeholder: "请输入Git分支" },
                      model: {
                        value: scope.row.branchName,
                        callback: function ($$v) {
                          _vm.$set(
                            scope.row,
                            "branchName",
                            typeof $$v === "string" ? $$v.trim() : $$v
                          )
                        },
                        expression: "scope.row.branchName",
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c(
            "el-table-column",
            {
              attrs: { "min-width": "160" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c("el-input", {
                        attrs: { size: "mini", placeholder: "__UNI__..." },
                        model: {
                          value: scope.row.uniAppId,
                          callback: function ($$v) {
                            _vm.$set(
                              scope.row,
                              "uniAppId",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "scope.row.uniAppId",
                        },
                      }),
                    ]
                  },
                },
              ]),
            },
            [
              _c(
                "template",
                { slot: "header" },
                [
                  _vm._v("\n        UniAppID\n        "),
                  _c(
                    "el-tooltip",
                    {
                      attrs: {
                        content: "请勿随意改动，否则将无法上传",
                        placement: "top",
                      },
                    },
                    [_c("i", { staticClass: "el-icon-question" })]
                  ),
                ],
                1
              ),
            ],
            2
          ),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "接口环境", width: "125" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-select",
                      {
                        attrs: { size: "mini" },
                        on: {
                          change: function ($event) {
                            return _vm.handleRowEnvironmentChange(
                              scope.row,
                              $event
                            )
                          },
                        },
                        model: {
                          value: scope.row.environmentCode,
                          callback: function ($$v) {
                            _vm.$set(scope.row, "environmentCode", $$v)
                          },
                          expression: "scope.row.environmentCode",
                        },
                      },
                      _vm._l(_vm.environments, function (item) {
                        return _c("el-option", {
                          key: item.code,
                          attrs: { label: item.name, value: item.code },
                        })
                      }),
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "CI机器人", width: "145", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.environmentCode === "CUSTOM"
                      ? _c("el-input-number", {
                          attrs: {
                            min: 5,
                            max: 30,
                            size: "mini",
                            "controls-position": "right",
                          },
                          model: {
                            value: scope.row.robotNo,
                            callback: function ($$v) {
                              _vm.$set(scope.row, "robotNo", $$v)
                            },
                            expression: "scope.row.robotNo",
                          },
                        })
                      : _c("span", [_vm._v(_vm._s(scope.row.robotNo))]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "目标域名", "min-width": "230" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.environmentCode === "CUSTOM"
                      ? _c("el-input", {
                          attrs: {
                            size: "mini",
                            placeholder: "https://example.com",
                          },
                          model: {
                            value: scope.row.customDomain,
                            callback: function ($$v) {
                              _vm.$set(
                                scope.row,
                                "customDomain",
                                typeof $$v === "string" ? $$v.trim() : $$v
                              )
                            },
                            expression: "scope.row.customDomain",
                          },
                        })
                      : _c("el-input", {
                          attrs: {
                            value: _vm.getTargetDomain(
                              scope.row.environmentCode
                            ),
                            size: "mini",
                            readonly: "",
                          },
                        }),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "更新体验版", width: "105", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("el-switch", {
                      model: {
                        value: scope.row.trialRequested,
                        callback: function ($$v) {
                          _vm.$set(scope.row, "trialRequested", $$v)
                        },
                        expression: "scope.row.trialRequested",
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "span",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            {
              on: {
                click: function ($event) {
                  _vm.visible = false
                },
              },
            },
            [_vm._v("取消")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              directives: [
                {
                  name: "has-permi",
                  rawName: "v-has-permi",
                  value: ["admin:miniapp:release:upload"],
                  expression: "['admin:miniapp:release:upload']",
                },
              ],
              attrs: { type: "primary", loading: _vm.submitting },
              on: { click: _vm.submit },
            },
            [_vm._v("统一上传")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }